// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * SRSLY design tokens — single source of truth.
 *
 * Two parallel token sets defined here:
 *
 * 1. HUD palette — semantic color/surface vars lifted verbatim from the
 *    landing app's original styles.css. Use these directly for
 *    landing-style HUD/terminal aesthetics: var(--cyan), var(--panel),
 *    var(--ink-mute), etc.
 *
 * 2. shadcn-compatible theme tokens — HSL-component vars that Tailwind
 *    consumes via hsl(var(--token)). Mapped onto the HUD palette so any
 *    component styled with bg-primary / text-foreground / border-input
 *    automatically picks up the SRSLY brand colors.
 *
 * This is dark-only; there is no light variant. The HUD aesthetic is
 * inherently dark-first.
 */

:root {
  /* ---------- HUD palette (semantic, hex) ---------- */

  --bg: #07111a;
  --bg-deep: #04090f;
  --panel: #0e1f2b;
  --panel-2: #0a1722;
  --line: rgba(120, 190, 220, 0.14);
  --line-bright: rgba(120, 200, 230, 0.28);

  --ink: #e6f1f7;
  --ink-dim: #c4d6e0;
  --ink-mute: #9bb0bd;

  --cyan: #22d3ee;
  --cyan-rgb: 34, 211, 238;
  --cyan-hsl: 189 86% 53%;
  --violet: #a78bfa;
  --violet-hsl: 256 92% 76%;
  --mint: #6ee7b7;
  --mint-hsl: 158 64% 67%;
  --amber: #f5c451;
  --amber-rgb: 245, 196, 81;
  --amber-hsl: 43 89% 64%;
  --danger: #f97373;
  --danger-hsl: 0 91% 72%;
  --ryden: #ff8a3c;
  --ryden-hsl: 21 100% 62%;

  /* ---------- shadcn theme tokens (HSL components, Tailwind-consumable) ----------
   *
   * Tailwind config wires \`hsl(var(--name))\` so utilities like \`bg-primary\`
   * resolve through these. Values mapped to the HUD palette above.
   */

  --background: 206 60% 6%; /* --bg */
  --foreground: 204 53% 94%; /* --ink */

  --card: 204 51% 11%; /* --panel */
  --card-foreground: 204 53% 94%; /* --ink */

  --popover: 204 51% 11%; /* --panel */
  --popover-foreground: 204 53% 94%; /* --ink */

  --primary: 189 86% 53%; /* --cyan */
  --primary-foreground: 205 60% 4%; /* --bg-deep (dark ink on cyan) */

  --secondary: 204 51% 11%; /* --panel */
  --secondary-foreground: 204 53% 94%; /* --ink */

  --muted: 205 51% 9%; /* --panel-2 */
  --muted-foreground: 200 18% 80%; /* --ink-mute */

  --accent: 256 92% 76%; /* --violet */
  --accent-foreground: 206 60% 6%; /* --bg */

  --destructive: 0 91% 72%; /* --danger */
  --destructive-foreground: 206 60% 6%; /* --bg */

  --border: 200 30% 22%; /* slightly bumped for visible panel edges */
  --input: 200 30% 22%;
  --ring: 189 86% 53%; /* --cyan */

  --radius: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/styles/tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF;EACE,sDAAsD;;EAEtD,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,wCAAwC;;EAExC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;;EAEnB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;;EAExB;;;;IAIE;;EAEF,wBAAwB,EAAE,SAAS;EACnC,yBAAyB,EAAE,UAAU;;EAErC,mBAAmB,EAAE,YAAY;EACjC,8BAA8B,EAAE,UAAU;;EAE1C,sBAAsB,EAAE,YAAY;EACpC,iCAAiC,EAAE,UAAU;;EAE7C,sBAAsB,EAAE,WAAW;EACnC,gCAAgC,EAAE,iCAAiC;;EAEnE,wBAAwB,EAAE,YAAY;EACtC,mCAAmC,EAAE,UAAU;;EAE/C,mBAAmB,EAAE,cAAc;EACnC,+BAA+B,EAAE,eAAe;;EAEhD,qBAAqB,EAAE,aAAa;EACpC,+BAA+B,EAAE,SAAS;;EAE1C,wBAAwB,EAAE,aAAa;EACvC,oCAAoC,EAAE,SAAS;;EAE/C,qBAAqB,EAAE,4CAA4C;EACnE,oBAAoB;EACpB,mBAAmB,EAAE,WAAW;;EAEhC,gBAAgB;AAClB","sourcesContent":["/*\n * SRSLY design tokens — single source of truth.\n *\n * Two parallel token sets defined here:\n *\n * 1. HUD palette — semantic color/surface vars lifted verbatim from the\n *    landing app's original styles.css. Use these directly for\n *    landing-style HUD/terminal aesthetics: var(--cyan), var(--panel),\n *    var(--ink-mute), etc.\n *\n * 2. shadcn-compatible theme tokens — HSL-component vars that Tailwind\n *    consumes via hsl(var(--token)). Mapped onto the HUD palette so any\n *    component styled with bg-primary / text-foreground / border-input\n *    automatically picks up the SRSLY brand colors.\n *\n * This is dark-only; there is no light variant. The HUD aesthetic is\n * inherently dark-first.\n */\n\n:root {\n  /* ---------- HUD palette (semantic, hex) ---------- */\n\n  --bg: #07111a;\n  --bg-deep: #04090f;\n  --panel: #0e1f2b;\n  --panel-2: #0a1722;\n  --line: rgba(120, 190, 220, 0.14);\n  --line-bright: rgba(120, 200, 230, 0.28);\n\n  --ink: #e6f1f7;\n  --ink-dim: #c4d6e0;\n  --ink-mute: #9bb0bd;\n\n  --cyan: #22d3ee;\n  --cyan-rgb: 34, 211, 238;\n  --cyan-hsl: 189 86% 53%;\n  --violet: #a78bfa;\n  --violet-hsl: 256 92% 76%;\n  --mint: #6ee7b7;\n  --mint-hsl: 158 64% 67%;\n  --amber: #f5c451;\n  --amber-rgb: 245, 196, 81;\n  --amber-hsl: 43 89% 64%;\n  --danger: #f97373;\n  --danger-hsl: 0 91% 72%;\n  --ryden: #ff8a3c;\n  --ryden-hsl: 21 100% 62%;\n\n  /* ---------- shadcn theme tokens (HSL components, Tailwind-consumable) ----------\n   *\n   * Tailwind config wires `hsl(var(--name))` so utilities like `bg-primary`\n   * resolve through these. Values mapped to the HUD palette above.\n   */\n\n  --background: 206 60% 6%; /* --bg */\n  --foreground: 204 53% 94%; /* --ink */\n\n  --card: 204 51% 11%; /* --panel */\n  --card-foreground: 204 53% 94%; /* --ink */\n\n  --popover: 204 51% 11%; /* --panel */\n  --popover-foreground: 204 53% 94%; /* --ink */\n\n  --primary: 189 86% 53%; /* --cyan */\n  --primary-foreground: 205 60% 4%; /* --bg-deep (dark ink on cyan) */\n\n  --secondary: 204 51% 11%; /* --panel */\n  --secondary-foreground: 204 53% 94%; /* --ink */\n\n  --muted: 205 51% 9%; /* --panel-2 */\n  --muted-foreground: 200 18% 80%; /* --ink-mute */\n\n  --accent: 256 92% 76%; /* --violet */\n  --accent-foreground: 206 60% 6%; /* --bg */\n\n  --destructive: 0 91% 72%; /* --danger */\n  --destructive-foreground: 206 60% 6%; /* --bg */\n\n  --border: 200 30% 22%; /* slightly bumped for visible panel edges */\n  --input: 200 30% 22%;\n  --ring: 189 86% 53%; /* --cyan */\n\n  --radius: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
